import "./App.css";
import Nav from './Nav/Nav';
import Login from './Login/Login';
import SignUp from './SignUp/Sign-Up';
import Generator from './Generator/Generator';
import About from './About/About';
import { Route, Routes, useNavigate } from "react-router-dom";
import {useState} from 'react';

function App() {
  const navigate = useNavigate();
  const[view, setView] = useState(true);
  return (
    <main className="App">
      <Nav/>
      <div className="container">
      <Routes>
      <Route exact path="/" element={<Generator/>} />
      <Route path="/login" element={<Login navigate={navigate} />} />
      <Route path="/sign-up" element={<SignUp navigate={navigate} />} />
      <Route path="/about" element={<About/>} />
      </Routes>
      </div>
    </main>
  );
}

export default App;
